<template>
    <div class="videoList">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <h1>{{ $t('videoList.h1')}}</h1>
        <div class="videoWarpper">
            <video ref="videoPlay" class="video" :src="src" controls autoplay controlslist="nodownload noremoteplayback"></video>
        </div>
        <ul class="list">
            <li v-for="(item, index) in videoSource" :key="index">
                <!-- <div class="imgWarpper" @click="play(item, index)">
                    <img v-if="videoImgList.length != 0" class="snapshot" :src="videoImgList[index].url" alt="" />
                    <div v-show="!item.playFlag" class="isPlay"><img src="../../assets/area/isplay.png" alt="" /></div>
                </div> -->
                <div class="msgWarpper">
                    <span>{{ item.name }}</span>
                    <div v-show="item.is_mark == 1" class="collect" @click="noCollect(item)">
                        <img src="../../assets/area/iscol.png" alt="" />
                        <span>已收藏</span>
                    </div>
                    <div v-show="item.is_mark == 0" class="collect" @click="isCollect(item)">
                        <img src="../../assets/area/nocol.png" alt="" />
                        <span>收藏</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
// import { exhibition_id } from "@/utils/exhibitId";
export default {
    data() {
        return {
            videoSource: [],
            videoSourceImg: [],
            src: "",
            activeNum: -1,
            instance_id: null,
            videoImgList: [],
            exhibition_id: ''
        };
    },
    mounted() {
        this.instance_id = Number(this.$route.query.instance_id);
        this.exhibition_id = this.$route.query.exhibition_id
        this.getExhibitionVideo();
    },
    methods: {
        getExhibitionVideo() {
            api.getExhibitionVideo({
                exhibition_id: this.exhibition_id,
                hall_id: this.instance_id,
                type: "video"
            }).then((res) => {
                console.log("视频列表", res);
                if (!res.data || !res.data.length) {
                    this.$message.info(this.$t("tips").noVideo);
                    return;
                }
                this.videoSource = res.data;
                let videoImgList = [];
                res.data.map((value) => {
                    console.log(value.fileId);
                    videoImgList.push(value.fileId);
                });
                if (res.data.length) {
                    this.src = res.data[0].url;
                    let str = videoImgList.join(",");
                    this.getSnapshot(str);
                }
            });
        },
        getSnapshot(str) {
            api.getSnapshot(str).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    this.videoImgList = res.list;
                }
            });
        },
        // this.src = res.data[0].url;
        backHome() {
            this.$root.$emit("close");
            this.$emit("cancel", 2);
        },
        play(item, index) {
            this.videoSource.map((item) => (item.playFlag = true));
            this.src = item.url;
            // this.src = item.resource.view_url;
            item.playFlag = false;
            this.activeNum = index;
            this.$refs.videoPlay.play();
        },
        stop(item) {
            this.$refs.videoPlay.pause();
            item.playFlag = true;
        },
        // 收藏视频
        isCollect(item) {
             if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                setTimeout(()=>{
                    this.$router.push({
                        path: '/login'
                    },3600)
                })
                return
            }else{
                api.isCollectVideo({
                    exhibition_id: this.exhibition_id,
                    resource_id: item.fileId
                }).then((res) => {
                    // console.log(res);
                    item.is_mark = 1;
                    this.$message.success("收藏成功");
                });
            }
            // console.log(item.resource.id);
        },
        // 取消视频收藏
        noCollect(item) {
            api.noCollectVideo({
                exhibition_id: this.exhibition_id,
                resource_id: item.fileId
            }).then((res) => {
                // console.log(res);
                item.is_mark = 0;
                this.$message.success("取消收藏");
            });
        }
    },
    computed: {
        videoList() {
            return this.$t("videoList");
        },
        ...mapState(["userInfo","language"]),
    },
    watch: {
        videoSource(val) {
            // console.log(val);
            if (val) {
                val.map((item) => {
                    this.$set(item, "playFlag", true);
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.videoList {
    width: 591px;
    background-color: #ffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    box-sizing: border-box;
    padding: 19px 33px;
    height: 508px;
    > h1 {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #09468c;
        line-height: 22px;
    }
    .videoWarpper {
        width: 100%;
        height: 296px;
        background-color: #ccc;
        margin-top: 20px;
        video {
            width: 100%;
            height: 100%;
        }
    }
    .list {
        width: 100%;
        margin-top: 14px;
        height: 135px;
        overflow-y: auto;
        > li {
            width: 100%;
            height: 120px;
            box-sizing: border-box;
            padding-top: 14px;
            display: flex;
            align-items: flex-start;
            .imgWarpper {
                width: 184px;
                height: 100%;
                position: relative;
                cursor: pointer;
                .isPlay {
                    position: absolute;
                    bottom: 6px;
                    left: 6px;
                    z-index: 2;
                    > img {
                        width: 21px;
                    }
                }
                .snapshot {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }
            .msgWarpper {
                flex: 1;
                height: 120px;
                box-sizing: border-box;
                padding: 13px 117px 0 13px;
                position: relative;
                > span {
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #09468c;
                    line-height: 14px;
                }
                .collect {
                    width: 70px;
                    height: 26px;
                    background: #09468c;
                    border-radius: 6px;
                    position: absolute;
                    right: 40px;
                    top: 7px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 0 8px;
                    cursor: pointer;
                    > span {
                        font-size: 11px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #ffffff;
                        line-height: 14px;
                        flex: 1;
                        text-align: center;
                    }
                    > img {
                        width: 18px;
                        height: 18px;
                    }
                }
            }
        }
    }
    .list::-webkit-scrollbar {
        width: 2px;
        height: 100%;
        background-color: #5f7185;
    }
    .list::-webkit-scrollbar-thumb {
        width: 2px;
        height: 20%;
        background-color: #0045c7;
    }

    .backHome {
        width: 33px;
        height: 33px;
        position: absolute;
        top: 21px;
        right: 21px;
        cursor: pointer;
        border-radius: 50%;
        > img {
            width: 100%;
            height: 100%;
        }
    }
    .backHome:hover {
        background-color: #e8eef4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/videoList/index.vue